import Textarea from '@cobliteam/colib-ui/Textarea';
import { Typography } from '@cobliteam/ui/components';
import type { BasicSurveyQuestion } from 'posthog-js';

interface Props {
  question: BasicSurveyQuestion;
  value?: string;
  onChange: (value: string) => void;
  hideTitle?: boolean;
}

const QuestionOpen = ({ question, value, onChange, hideTitle = false }: Props) => {
  return (
    <div className='flex flex-col gap-2'>
      {!hideTitle && (
        <Typography variant='text-sm' className='font-medium'>
          {question.question}
        </Typography>
      )}
      <Textarea value={value ?? ''} onChange={(e) => onChange(e.target.value)} rows={3} placeholder={question.description ?? undefined} />
    </div>
  );
};

export default QuestionOpen;
